import { configure } from 'mobx'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import 'swiper/css'
import 'swiper/css/navigation'

import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'
import arrierePublic from '@avantstay/arriere-clients/dist/arrierePublic'
import { enableSidePanelContentModeToggle } from '@avantstay/backoffice-core'

import '@arriere/backofficeRouter'
import { ClerkProvider } from '@clerk/react'
// Side-effect import: keeps RoutingStore in the bundle so setRoutingStore() runs
// before any consumer of computedRouteParam evaluates.
import '@stores/RoutingStore'
import '@utils/validateExtends'

import MainRouter from './MainRouter'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY || !PUBLISHABLE_KEY.startsWith('pk_')) {
  const errorMessage =
    'Invalid or missing Clerk Publishable Key. Please set VITE_CLERK_PUBLISHABLE_KEY in apps/voyage/.env.local with a real key (starting with "pk_") from your Clerk Dashboard.'
  console.error(errorMessage)
  throw new Error(errorMessage)
}

configure({ enforceActions: 'never' })

// Voyage's DefaultTemplate reacts to the push/overlay preference, so surface
// the toggle in side panel headers here
enableSidePanelContentModeToggle()

if (process.env.REACT_APP_LIVE_API_MOCKING === 'true') {
  import('./__mocks__').then(({ setupMocks }) => setupMocks())
}

// eslint-disable-next-line camelcase
window._fs_ready = () => {
  if (!window.FS) return

  const session = window.FS.getCurrentSession()
  const sessionUrl = window.FS.getCurrentSessionURL()

  const apis = [arriereBackoffice, arrierePublic]

  apis.forEach(api => {
    api.setHeader('X-Fullstory-Session-ID', session)
    api.setHeader('X-Fullstory-Session-URL', sessionUrl)
  })
}

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
    <MainRouter />
  </ClerkProvider>,
)

export { useGlobalStyle } from '@new/__global/hooks/useGlobalStyle'
